
export const moderatorsTableConfig = () => {
    return [

        {
            id: "name",
            header: "Наименование",
            field: "name"
        },
        {
            id: "login",
            header: "Логин",
            field: "login",
        },
        {
            id: "password",
            header: "Пароль",
            field: "password",
        },
        {
            id: "access",
            header: "Доступы",
            field: "access",
        },
        {
            id: "actions",
            header: "",
            field: "address",
        },
    ];
}
